module.exports = __webpack_public_path__ + "static/media/debateImage2.4a6526a8.png";